// Module
var code = "<react-component name=\"EditStyle\"></react-component>\n";
// Exports
module.exports = code;